module.exports = __webpack_public_path__ + "img/trush.9828acfd.svg";